var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.447,
    height: 10.907,
    viewBox: "0 0 13.447 10.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M42.258,12.907A7.774,7.774,0,0,0,50.1,5.063V4.689A6.072,6.072,0,0,0,51.447,3.27a6.2,6.2,0,0,1-1.569.448,2.906,2.906,0,0,0,1.2-1.494,6.852,6.852,0,0,1-1.718.672A2.668,2.668,0,0,0,47.338,2a2.807,2.807,0,0,0-2.764,2.764,1.456,1.456,0,0,0,.075.6,7.724,7.724,0,0,1-5.677-2.913A2.861,2.861,0,0,0,38.6,3.868a2.968,2.968,0,0,0,1.2,2.316,2.518,2.518,0,0,1-1.27-.374h0A2.73,2.73,0,0,0,40.764,8.5a2.3,2.3,0,0,1-.747.075,1.271,1.271,0,0,1-.523-.075,2.83,2.83,0,0,0,2.615,1.942,5.64,5.64,0,0,1-3.436,1.2A2.068,2.068,0,0,1,38,11.562a7.051,7.051,0,0,0,4.258,1.345",
    transform: "translate(-38 -2)",
    fill: "#165227",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.a0897200a14a745482880612d9933598.svg";
export { ForwardRef as ReactComponent };